import { EFeatureFlag, LocalDataKeys, TFeatureFlags } from '@libs/types';
import { useLocalData } from './useLocalData';

/**
 * Reads a backend feature flag from `configuration.featureFlags` (sent with `requestInteraction`), persisted in
 * localStorage by the scenario thunks. Synchronous on the first render — also after a reload — and live on every new
 * response.
 *
 * @param flag flag name, e.g. `EFeatureFlag.Rebranding`
 * @param fallback value used when the backend never sent the flag
 * @returns the last received flag value, or `fallback`
 */
export const useFeatureFlag = (flag: EFeatureFlag, fallback = false): boolean => useLocalData<TFeatureFlags>(LocalDataKeys.featureFlags)?.[flag] ?? fallback;
